import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=33258bbb&scoped=true&"
import script from "./activity-details.vue?vue&type=script&lang=js&"
export * from "./activity-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-details.vue?vue&type=style&index=0&id=33258bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33258bbb",
  null
  
)

export default component.exports